import Vue from 'vue'

export default {
    state: {
        dayItems: [][0]
    },
    getters: {
        currentDayItems: state => {
            return state.dayItems
        }
    },
    mutations: {
        initDayItems (state, items) {
            state.dayItems = items
        },
        updateDayItem (state, payload) {
            const keys = Object.keys(payload)
            keys.forEach((key, _, __) => {
                Vue.set(state.dayItems[payload.week][payload.dayIndex], key, payload[key])
            })
        },
        addItem (state, payload) {
            state.dayItems[payload.week][payload.dayIndex] = payload
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/schedule/ScheduleStore.js